import { render, staticRenderFns } from "./PrintPosFaCiadeV1.vue?vue&type=template&id=62a332db&scoped=true"
import script from "./PrintPosFaCiadeV1.vue?vue&type=script&lang=js"
export * from "./PrintPosFaCiadeV1.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFaCiadeV1.vue?vue&type=style&index=0&id=62a332db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a332db",
  null
  
)

export default component.exports